import { ChevronRight, FileText, Plus, Store, Users2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const HostDashboardHeader = ({ onNavigate }) => (
  <header
    className="mobile-page-header sticky top-0 z-30 border-b border-gray-200 bg-white"
    style={{ paddingTop: 'max(1rem, env(safe-area-inset-top))' }}
  >
    <div
      className="mx-auto flex max-w-6xl flex-col items-stretch gap-3 px-4 pb-4 sm:flex-row sm:items-center sm:justify-between"
      data-testid="host-dashboard-header-layout"
    >
      <div className="flex min-w-0 items-center gap-3" data-testid="host-dashboard-heading-group">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onNavigate('/dashboard')}
          className="mobile-page-back shrink-0 text-gray-600 hover:text-gray-900"
          data-testid="back-to-dashboard-btn"
          aria-label="Back to dashboard"
        >
          <ChevronRight className="h-5 w-5 rotate-180" />
        </Button>
        <div className="min-w-0">
          <h1 className="break-words text-xl font-bold text-gray-900">Host Dashboard</h1>
          <p className="text-sm text-gray-500">Manage your runs</p>
        </div>
      </div>

      <div
        className="flex w-full max-w-full flex-wrap gap-2 sm:w-auto sm:justify-end"
        data-testid="host-dashboard-header-actions"
      >
        <Button
          onClick={() => onNavigate('/my-trainer-page')}
          variant="outline"
          className="border-zinc-200 text-zinc-700 hover:bg-zinc-50"
          data-testid="my-trainer-page-btn"
        >
          <Store className="mr-2 h-4 w-4" />
          My Trainer Page
        </Button>
        <Button
          onClick={() => onNavigate('/host/reports')}
          variant="outline"
          className="border-zinc-200 text-zinc-700 hover:bg-zinc-50"
          data-testid="host-reports-btn"
        >
          <FileText className="mr-2 h-4 w-4" />
          Reports
        </Button>
        <Button
          onClick={() => onNavigate('/create-club')}
          variant="outline"
          className="border-orange-200 text-orange-600 hover:bg-orange-50"
          data-testid="create-club-btn"
        >
          <Users2 className="mr-2 h-4 w-4" />
          Create Club
        </Button>
        <Button
          onClick={() => onNavigate('/create-game')}
          className="bg-orange-500 hover:bg-orange-600"
          data-testid="create-run-btn"
        >
          <Plus className="mr-2 h-4 w-4" />
          Create Run
        </Button>
      </div>
    </div>
  </header>
);

export default HostDashboardHeader;
